// extracted by mini-css-extract-plugin
module.exports = {"SectionF":"SectionF_SectionF__29rs4"};